/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetFeedbackDataApiFrom } from '../../models/set-feedback-data-api-from';

export interface ApiV3ServiceSetfeedbackPost$Params {

/**
 * Interface language.
 */
  lang?: string;
  
    /**
     * Data for saving customer feedback on a record from the transaction history.
     */
    body?: SetFeedbackDataApiFrom
}

export function apiV3ServiceSetfeedbackPost(http: HttpClient, rootUrl: string, params?: ApiV3ServiceSetfeedbackPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiV3ServiceSetfeedbackPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiV3ServiceSetfeedbackPost.PATH = '/api/v3/service/setfeedback';
